const page = 'Andes_v2';
export const OPEN_PCB_CHANNEL_RESULT = `${page}_open_pcb_channel_result`;
export const CHANGE_RESULT_TYPE = `${page}_change_channel_result_type`;
export const SAVE_ANDES_RESULT = `${page}_save_andes_result`;
export const GET_HISTORY_LIST = `${page}_get_history_list`;
export const UPDATE_HISTORY_LIST = `${page}_update_history_list`;
export const OPEN_END_TO_END_CHANNEL_RESULT = `${page}_open_end_to_end_channel_result`;
export const OPEN_EXPERIMENT_RESULT = `${page}/open_experiment_result`;
